angular.module('BlogControllers')
  .service('blog', ['$q', 'localData', 'EXAM', 'api', function($q, localData, EXAM, api) {
    this.articles = null;

    var self = this;
    this.getArticles = function () {
      var defer = $q.defer();
      api.sync(api.getArticles, function (articles) {
        self.articles = articles;
        console.log("articles", articles);
        defer.resolve(articles);
      });
      return defer.promise;
    };

    this.getArticleByUrl = function (slugTitle) {
      var defer = $q.defer();
      this.getArticles().then(function(articles){
        // check if article exist
        var article;
        for (var i = 0; i < articles.length; i++) {
          if (articles[i].slug === slugTitle) {
            article = articles[i];
            break;
          }
        }

        if (article) {
          defer.resolve(article);
        } else {
          defer.reject();
        }
      });
      return defer.promise;
    };
  }
  ]);
